import React from 'react';
//import { useStyles } from '../styles';
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";

export default function CartButton(props) {
  //const styles = useStyles();
  return (
     <div className="cart_dox" onClick={()=>props.handleCart(props.itemsCount)}>
      <span className="cart_count">
          {props.itemsCount}
        </span>
        <div style={{textAlign:'center',width:'38px',height:'20px',lineHeight:1}} >
        <ShoppingBagIcon sx={{ cursor: "pointer", color: "white" }} />
        <div style={{fontSize:"0.8em", color:"#fff", width:"100px", textAlign:"left"}}>My Order</div>
        </div>
      
      </div>
  );
}
